import {
  apiRegister
} from '../../common/api';

/*
协议Id 
913
项目 
模块 
方式 
https 
命令（路径） 
/award/match/addrewarduserinfo/
说明
填写获奖信息
*/

const addAddress = apiRegister('add-address',  {
  protoId: 913,
  path: '/award/match/addrewarduserinfo/',
  // checkResult(R) {
  //   if (!isPlain(R.info)) {
  //     return ERR_REP_MY_DETAIL // 数据格式非法
  //   }
  //   return 0
  // },
  formatResult(R) {
    return R
  }
})

export const addAddressLoad = addAddress.send
